<script>
	import DropdownCheckbox from "../../../../components/DropdownCheckbox/DropdownCheckbox.svelte";
	import CustomButton from "../../../../components/CustomButton/CustomButton.svelte";
	import CustomDatePicker from "../../../../components/CustomDatePicker/CustomDatePicker.svelte";
	import CustomSearch from "../../../../components/CustomSearch/CustomSearch.svelte";
	import LimitSize from "../../../../components/SizeSelect/limitSize.svelte";
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import { initPage } from "src/store/store";
	import { navigate } from "svelte-routing";
	import { debounce } from "lodash";
	import {
		caseStatusOptions,
		damageLocationDropdownCheckBoxOptions,
	} from "src/utils/options";
	import CustomInput from "src/components/CustomInput/CustomInput.svelte";
	import LastUpdatedDateTime from "src/components/LastUpdatedDateTime/LastUpdatedDateTime.svelte";
	import { getOrDefault, updateCheckboxOptions } from "src/utils/misc";

	export let handleVehicleSearch = () => {};
	export let changeSearchParams = () => {};
	export let params = {};

	let isOpen = false;

	$: options = updateCheckboxOptions(
		damageLocationDropdownCheckBoxOptions,
		params.damageLocation
	);
	$: plateNo = getOrDefault(params.plateNo, "");
	$: vehicleId = getOrDefault(params.vehicleId, "");
	$: createdAt = getOrDefault(params.createdAt, "");
	$: caseNo = getOrDefault(params.caseNo, "");
	$: status = getOrDefault(params.status, "");

	const debouncedInput = debounce((e) => handleChange(e), 1000);

	function handleChange(value) {
		changeSearchParams({ ...value, page: 1, pageNumber: 1 });
		initPage.set(1);
	}

	function resetFilter() {
		initPage.set(1);
		navigate("/issues/case-management" + `?tab=${0}`);
		changeSearchParams("");
	}

	function toggle() {
		isOpen = !isOpen;
	}
</script>

<Row style="padding-right: 0">
	<Col xs={12}>
		<Row>
			<Col xs={10}>
				<Row class="gx-2">
					<Col>
						<CustomSearch
							loadOptions={handleVehicleSearch}
							id={`plateNo`}
							type="text"
							placeholder={`Vehicle No`}
							bind:value={plateNo}
							containerClasses={`search-icon`}
							onSelect={(e) => {
								plateNo = e.detail.label;
								vehicleId = e.detail.value;
								handleChange({
									vehicleId,
									plateNo,
								});
							}}
							handleClear={() => {
								plateNo = "";
								vehicleId = "";
								handleChange({
									vehicleId,
									plateNo,
								});
							}}
						/>
					</Col>
					<Col>
						<CustomInput
							placeholder="Case No"
							search
							bind:value={caseNo}
							onInput={(e) =>
								debouncedInput({
									[e.target.name]: e.target.value,
								})}
							name="caseNo"
						/>
					</Col>
					<Col>
						<CustomDatePicker
							onChange={(e) => {
								handleChange({
									createdAt: e.detail,
								});
								e.target.blur();
							}}
							value={createdAt}
							name="createdAt"
							isRange={false}
							placeholder={"Incident Date"}
						/>
					</Col>
					<Col>
						<CustomSearch
							items={caseStatusOptions}
							isSearchable={false}
							placeholder="Status"
							id="status"
							bind:value={status}
							onSelect={(e) => {
								if (e.detail.value !== params.status) {
									status = e.detail.value;
									handleChange({
										status,
									});
								}
							}}
							handleClear={() => {
								status = "";
								handleChange({
									status,
								});
							}}
						/>
					</Col>
				</Row>
			</Col>
		</Row>
		<Row class="mb-3">
			<Col xs={9}>
				<Row class="gx-2">
					<Col xs={3}>
						<DropdownCheckbox
							categoryName="Damage Location"
							{options}
							{isOpen}
							{toggle}
							refetch={handleChange}
							id="damageLocation"
						/>
					</Col>
					<Col class="d-flex align-items-center">
						<CustomButton
							style="border-color: transparent; font-weight: bold;"
							buttonText="Clear filters"
							on:click={resetFilter}
							color="secondary"
							onKeyDown={() => {}}
						/>
					</Col>
				</Row>
			</Col>
			<Col xs={3} style="position:relative; padding-right:0">
				<LimitSize />

				<!-- DONT FORGET TO CHANGE TO REAL DATE FROM BE -->
				<div class="d-flex justify-content-end">
					<LastUpdatedDateTime />
				</div>
			</Col>
		</Row>
	</Col>
</Row>
